<template>
  <b-dropdown
    block
    variant="outline-secondary"
    class="w-100 mr-2"
    :menu-class="'w-100 p-0'"
    toggle-class="d-flex justify-content-between  w-100"
    no-caret
    style="width-[800px]"
  >
    <template #button-content>
      <div class="text-truncate" :class="{ 'text-muted': !selectedIds.length }">{{ buttonText }}</div>
      <b-badge v-if="selectedIds.length" variant="primary" class="ml-2">
        {{ selectedIds.length }}
      </b-badge>
    </template>

    <!-- stop mousedown biar klik di dalam menu nggak nutup dropdown -->
    <div class="p-2" @mousedown.stop>
      <b-form-input
        v-model="search"
        size="sm"
        placeholder="Cari..."
        class="mb-2"
      />

<div class="d-flex justify-content-between align-items-center mb-2">
  <b-form-checkbox
    class="cb-text-left"
    :indeterminate="indeterminate"
    :checked="allVisibleSelected"
    @change="toggleSelectAll"
  >
    Pilih semua
  </b-form-checkbox>
  <b-button size="sm" variant="link" @click="clear">Clear</b-button>
</div>

<div style="max-height: 260px; overflow:auto; padding-right: 4px;">
  <b-form-checkbox-group
    v-model="selectedIds"
    :options="checkboxOptions"
    stacked
    class="cb-text-left filter-form-wrapper big-filter-label"
  />
</div>

    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'MultiSelectDropdown',
  props: {
    value: { type: Array, default: () => [] },           // v-model (array of id)
    options: { type: Array, required: true },            // [{ id, name }]
    valueField: { type: String, default: 'value' },      // 'id'
    textField: { type: String, default: 'text' },        // 'name'
    placeholder: { type: String, default: 'Pilih...' },
    maxLabel: { type: Number, default: 2 },              // tampilkan max 2 label di tombol
  },
  data() {
    return { search: '' }
  },
  computed: {
    selectedIds: {
      get() { return this.value || [] },
      set(v) { this.$emit('input', v) },
    },
    filteredOptions() {
      const tf = this.textField
      const q = this.search.trim().toLowerCase()
      if (!q) return this.options
      return this.options.filter(o => String(o[tf]).toLowerCase().includes(q))
    },
    checkboxOptions() {
      const vf = this.valueField, tf = this.textField
      return this.filteredOptions.map(o => ({ text: o[tf], value: o[vf] }))
    },
    // tombol: placeholder | "Nama1, Nama2 +N"
    buttonText() {
      if (!this.selectedIds.length) return this.placeholder
      const vf = this.valueField, tf = this.textField
      const mapById = new Map(this.options.map(o => [o[vf], o]))
      const labels = this.selectedIds
        .map(id => mapById.get(id))
        .filter(Boolean)
        .map(o => o[tf])

      const shown = labels.slice(0, this.maxLabel).join(', ')
      const more = this.selectedIds.length - this.maxLabel
      return more > 0 ? `${shown} +${more}` : shown || this.placeholder
    },
    allVisibleSelected() {
      if (!this.filteredOptions.length) return false
      const visibleIds = new Set(this.filteredOptions.map(o => o[this.valueField]))
      return [...visibleIds].every(id => this.selectedIds.includes(id))
    },
    indeterminate() {
      if (!this.filteredOptions.length) return false
      const visibleIds = new Set(this.filteredOptions.map(o => o[this.valueField]))
      const count = [...visibleIds].filter(id => this.selectedIds.includes(id)).length
      return count > 0 && count < visibleIds.size
    },
  },
  methods: {
    toggleSelectAll(checked) {
      const visibleIds = this.filteredOptions.map(o => o[this.valueField])
      if (checked) {
        // union: tambahkan semua yang terlihat
        const set = new Set([...this.selectedIds, ...visibleIds])
        this.selectedIds = [...set]
      } else {
        // minus: hapus semua yang terlihat
        const vis = new Set(visibleIds)
        this.selectedIds = this.selectedIds.filter(id => !vis.has(id))
      }
    },
    clear() {
      this.selectedIds = []
      this.search = ''
    },
  },
}
</script>

<style scoped>
/* biar badge dan teks rapi saat tombol sempit */
.dropdown-toggle > .text-truncate { max-width: calc(100% - 2rem); }

/* ===== Checkbox label kiri (BootstrapVue v2 - .custom-control) ===== */
:deep(.cb-text-left .custom-control) {
  display: flex;
  align-items: center;
  justify-content: flex-start !important;  /* <-- kiri */
  padding-left: 0;
}
:deep(.cb-text-left .custom-control-input) {
  position: static;
  margin-right: .5rem;
}
:deep(.cb-text-left .custom-control-label) {
  margin: 0;
  flex: 1 1 auto;
  justify-content: left;
  white-space: normal;
}

.custom-control-label{

  justify-content: left;
}

/* Kalahkan rule .form-inline .custom-control { justify-content:center } */
@media (min-width: 576px) {
  :deep(.form-inline .cb-text-left .custom-control) {
    justify-content: flex-start !important;
  }
}

/* ===== Bootstrap 5 fallback (.form-check) – kalau suatu saat pindah ke BS5 ===== */
:deep(.cb-text-left .form-check) {
  display: flex;
  align-items: center;
  justify-content: left;
}
:deep(.cb-text-left .form-check-input) { margin-right: .5rem; }
:deep(.cb-text-left .form-check-label) {
  margin: 0;
  flex: 1 1 auto;
  text-align: left !important;
}
.big-filter-label.filter-form-wrapper .form-inline label {
  display: flex;                    /* supaya justify-content berfungsi */
  justify-content: left; /* ratakan kiri, kalahkan bootstrap */
  /* width: 135px;  <-- aktifkan kalau kamu memang mau fixed width */
}


.form-inline label {
  display: flex;                  /* wajib agar justify-content bekerja */
  justify-content: flex-start !important;
}
</style>
